import React, { useEffect, useState } from "react";
import { Bounce, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useAuth } from "../../../../context/AuthContext";
import classes from "./AddDocumentsRecords.module.css";
import QuestionCard from "../../../ui/QuestionCard/QuestionCard";
import QuestionBox from "../../../ui/QuestionBox/QuestionBox";
import CommonFooter from "../../../CommonFooter/CommonFooter";
import ScoredInputRow from "../../../ui/ScoredInputRow/ScoredInputRow";
import { env } from "../../../../constants/env";
import QuestionSection from "../../../ui/QuestionSection/QuestionSection";

// Points configuration for each question
const QUESTION_POINTS = {
  1.1: 10,
  "1.2a": 5,
  "1.2b": 5,
  "1.2c": 5,
  "1.2d": 5,
  "1.2e": 5,
  "1.2f": 5,
  "1.2g": 5,
  1.3: 10,
  1.4: 10,
  "1.5a": 5,
  "1.5b": 5,
  1.6: 10,
  1.7: 10,
  1.8: 10,
  1.9: 10,
  "1.10": 10,
};

const questionSets = [
  {
    render: (onAnswerChange, answers, editable) => (
      <>
        <QuestionSection
          number="1.1"
          title="Legal Entity"
          questions={[
            {
              content:
                "Does the laboratory have documentation stating its legal identity?...",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.2"
          title="Laboratory management system policies and objectives"
          questions={[
            {
              content:
                "Quality policy statement that includes scope of service, standard of service, measurable objectives of the laboratory management system, and management commitment to compliance to the implementation of the policies;",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Documented policies of the laboratory management system that meet the requirements of ISO15189:2022 and the requirements of the accreditation bodies (where relevant);",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Description of the laboratory management system and the structure of its documentation;",
              number: "c",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Reference to supporting procedures (e.g., SOPs), including managerial and technical procedures;",
              number: "d",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Description of the roles and responsibilities of the laboratory director (however named) and other key personnel responsible for ensuring compliance with the established organizational structure (organogram)",
              number: "e",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Record of review and approval of this document (quality manual or equivalent) by authorized personnel;",
              number: "f",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Records to show that relevant sections of this document were communicated to and understood by the relevant personnel (internal and external persons).",
              number: "g",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.3"
          title="Document and Information Control System"
          questions={[
            {
              content:
                "Has the laboratory management established and implemented a document control system to control all documents and information from internal and external sources?.",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.4"
          title="Document and Records"
          questions={[
            {
              content:
                "Are there records detailing all documents of the laboratory management system and indicating their editions and distribution?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.5"
          title="Laboratory Management System Documentation"
          questions={[
            {
              content:
                "Has the laboratory management established, documented and maintained objectives and policies to fulfil the requirements of ISO 15189:2022 standards?",
              number: "a",
              multiline: true,
              placeholder: "Add comment",
            },
            {
              content:
                "Are these objectives and policies acknowledged and implemented at all levels of the laboratory?",
              number: "b",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.6"
          title="Quality Document Accessibility"
          questions={[
            {
              content:
                "Are quality documents (paper based and/or electronic copies) easily accessible, available and written in a language commonly understood and communicated to all relevant personnel?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.7"
          title="Document Control Record"
          questions={[
            {
              content:
                "Do all quality documents have a record to reflect when it was approved for use, its review and revision history, its version, its location and when it was discontinued?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.8"
          title="Discontinued Quality Documents"
          questions={[
            {
              content:
                "Are invalid or discontinued quality documents identified, clearly marked, removed from use and one copy retained for reference purposes?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.9"
          title="Data Files"
          questions={[
            {
              content:
                "Are test results, technical and quality records archived for a specified period in accordance with the requirements of Section 9 of this checklist?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />

        <QuestionSection
          number="1.10"
          title="Archived Patient Results Accessibility"
          questions={[
            {
              content:
                "Are test results, technical and quality records archived for a specified period in accordance with the requirements of Section 9 of this checklist?",
              multiline: true,
              placeholder: "Add comment",
            },
          ]}
          onAnswerChange={onAnswerChange}
          answers={answers}
          disabled={!editable}
        />
      </>
    ),
  },
];

const AddDocumentsRecords = () => {
  const navigate = useNavigate();
  const [currentSet, setCurrentSet] = useState(0);
  const { user, token } = useAuth();
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const { labId, questionnaireId } = useParams(); // ✅ get questionnaireId too

  const editable = questionnaireId ? status === "Not Attached" : true;

  // --- Prefill answers if editing ---
  useEffect(() => {
    const fetchQuestionnaire = async () => {
      if (!questionnaireId) return; // new form
      try {
        setLoading(true);
        const response = await fetch(
          `${env.kataApiUrl}/api/certification/id/${questionnaireId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to load questionnaire");
        }

        const data = await response.json();

        console.log("DATATAA", data);

        setStatus(data.status);

        const prefilled = {};
        if (data.answers && Array.isArray(data.answers)) {
          data.answers.forEach((ans) => {
            prefilled[ans.questionNumber] = {
              score: ans.score,
              comment: ans.comment,
              points: ans.points,
            };
          });
        }

        setAnswers(prefilled);
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestionnaire();
  }, [questionnaireId, token]);

  const handleAnswerChange = (questionNumber, score, comment, points) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [questionNumber]: {
        score,
        comment,
        points: points ? Number(points) : undefined,
      },
    }));
  };

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) setCurrentSet(currentSet + 1);
  };

  const handlePrevious = () => {
    if (currentSet > 0) setCurrentSet(currentSet - 1);
  };

  const submitAssessment = async () => {
    const answersArray = Object.entries(answers).map(
      ([questionNumber, data]) => ({
        questionNumber,
        score: data.score,
        comment: data.comment,
        points: data.points,
      })
    );

    const payload = {
      name: "SLIPTA",
      labId,
      section: "Documents & Records",
      auditorId: user.id,
      answers: answersArray,
    };

    const url = questionnaireId
      ? `${env.kataApiUrl}/api/certification/id/${questionnaireId}` // edit
      : `${env.kataApiUrl}/api/certification/submit`; // create

    const method = questionnaireId ? "PUT" : "POST";

    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Submission failed");
    }

    return await response.json();
  };

  const handleDone = async () => {
    try {
      if (Object.keys(answers).length === 0) {
        toast.warning("Please answer at least one question before submitting");
        return;
      }

      await submitAssessment();

      toast.success(
        questionnaireId ? "updated successfully!" : "Submitted successfully!"
      );

      navigate(-1);
    } catch (error) {
      toast.error(error.message || "Failed to submit assessment");
    }
  };

  return (
    <div
      className={`${classes.wrapper} ${!editable ? classes.fromParams : ""}`}
    >
      <div
        className="d-flex align-items-center gap-2 mb-4"
        onClick={() => navigate(-1)}
        role="button"
      >
        <IoIosArrowRoundBack size={35} />
        <h2 className="m-0">
          Section 01: Documents & Records {questionnaireId && "(Editing)"}
        </h2>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {questionSets[currentSet].render(
            handleAnswerChange,
            answers,
            editable
          )}

          {editable && (
            <CommonFooter
              handlePrevious={handlePrevious}
              handleCancel={() => navigate(-1)}
              handleNext={handleNext}
              handleDone={handleDone}
              questionSets={questionSets}
              currentSet={currentSet}
              cancelText="Cancel"
              doneText={
                questionnaireId ? "Update Assessment" : "Submit Assessment"
              }
            />
          )}
        </>
      )}
    </div>
  );
};

export default AddDocumentsRecords;
